import Vue from 'vue'
import Router from 'vue-router'
// import store from '../store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: function (resolve) {
        require(['@/components/auth/auth.vue'], resolve)
      }
    },
    {
      path: '/',
      name: 'Dashboard',
      component: function (resolve) {
        require(['@/components/dashboard/dashboard.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/accounts',
      name: 'Accounts',
      component: function (resolve) {
        require(['@/components/account/account.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/themes',
      name: 'Themes',
      component: function (resolve) {
        require(['@/components/theme/theme.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/themes/usage/:themeId',
      name: 'ThemeUsage',
      props: true,
      component: function (resolve) {
        require(['@/components/theme/components/themeUsage/themeUsage.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/templates/theme/:themeId',
      name: 'TemplatesByTheme',
      props: true,
      component: function (resolve) {
        require(['@/components/template/template.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/collections/theme/:themeId',
      name: 'CollectionsByTheme',
      props: true,
      component: function (resolve) {
        require(['@/components/collection/collection.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/snippets/theme/:themeId',
      name: 'SnippetsByTheme',
      props: true,
      component: function (resolve) {
        require(['@/components/snippet/snippet.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/plugins',
      name: 'Plugins',
      component: function (resolve) {
        require(['@/components/plugin/plugin.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/users',
      name: 'Users',
      component: function (resolve) {
        require(['@/components/user/user.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/customers',
      name: 'Customers',
      component: function (resolve) {
        require(['@/components/customer/customer.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/sendunit',
      name: 'Sendunit',
      component: function (resolve) {
        require(['@/components/sendunit/sendunit.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/sendunitpool',
      name: 'SendunitPool',
      component: function (resolve) {
        require(['@/components/sendunitPool/sendunitPool.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/sendmanager',
      name: 'SendManager',
      component: function (resolve) {
        require(['@/components/sendManager/sendManager.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/settings',
      name: 'Settings',
      component: function (resolve) {
        require(['@/components/settings/settings.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/mailingTemplates',
      name: 'MailingTemplates',
      component: function (resolve) {
        require(['@/components/mailingTemplate/mailingTemplate.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/triggerTypes',
      name: 'TriggerTypes',
      component: function (resolve) {
        require(['@/components/triggerType/triggerType.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/languages',
      name: 'languages',
      component: function (resolve) {
        require(['@/components/languages/languages.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/blacklist',
      name: 'blacklist',
      component: function (resolve) {
        require(['@/components/blacklist/blacklist.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/statistics',
      name: 'statistics',
      component: function (resolve) {
        require(['@/components/statistics/statistics.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/idpUser',
      name: 'IDPUser',
      component: function (resolve) {
        require(['@/components/idpUser/idpUser.vue'], resolve)
      },
      beforeEnter: guardRoute
    },
    {
      path: '/externalIDP',
      name: 'ExternalIDP',
      component: function (resolve) {
        require(['@/components/externalIDP/externalIDP.vue'], resolve)
      },
      beforeEnter: guardRoute
    }
  ]
})

function guardRoute (to, from, next) {
  // Currently only a placeholder for future changes
  next()
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js